export const en = {
  common: {
    loading: 'Loading...',
    email: 'Email',
    emailRequired: 'Please enter your email!',
    emailValid: 'Please enter a valid email address!',
    password: 'Password',
    passwordRequired: 'Please enter your password!',
    passwordMin: 'Password must be at least 6 characters!',
    confirmPassword: 'Confirm Password',
    confirmPasswordRequired: 'Please confirm your password!',
    confirmPasswordNotMatch: 'The two passwords do not match!',
    phone: 'Phone',
    phoneRequired: 'Please enter your phone!',
    phoneValid: 'Please enter a valid phone number!',
    code: 'Verification Code',
    codeRequired: 'Please enter the verification code!',
    back: 'Back',
    and: 'and',
    agreementUser: 'User Agreement',
    agreementPrivacy: 'Privacy Policy',
    submit: 'Submit',
    contact: 'Contact Info',
    feedback: 'Feedback',
    success: 'Success',
    fail: 'Failed',
    nickname: 'Nickname',
    avatar: 'Avatar',
    language: 'Language',
    logout: 'Logout',
    privacy: 'Privacy Policy',
    manual: 'User Guide',
    userAgreement: 'User Agreement',
    ok: 'OK',
    move: 'Move',
    cancel: 'Cancel',
    delete: 'Delete',
    deleteForever: 'Delete Permanently',
    edit: 'Edit',
    warning: 'Warning',
    info: 'Info',
    yes: 'Yes',
    no: 'No',
    copy: 'Copy',
    export: 'Export',
    save: 'Save',
    close: 'Close',
    empty: 'No Data',
    input: 'Please enter',
    name: 'Name',
    newName: 'New Name',
    unchanged: 'No change',
    updateSuccess: 'Update successful',
    updateFail: 'Update failed, please try again later',
    deleteSuccess: 'Delete successful',
    deleteFail: 'Delete failed, please try again later',
    confirmDelete: 'Confirm Delete',
    confirm: 'Confirm',
    know: 'Got it',
    file: 'File',
    sessionExpired: 'Session expired, please log in again',
    noPermission: 'No permission to access this resource',
    resourceNotFound: 'Requested resource not found',
    methodNotAllowed: 'Request method not allowed',
    serverError: 'Server error, please try again later',
    networkError: 'Network error, please check your connection',
    requestConfigError: 'Request configuration error',
    requestFailed: 'Request failed',
    fileName: 'File Name',
    fileType: 'File Type',
    fileList: 'File Records',
    operation: 'Operation',
    rename: 'Rename',
    sync: 'Sync',
    detail: 'Detail',
    download: 'Download',
    retry: 'Retry',
    start: 'Start',
    stop: 'Stop',
    continue: 'Continue',
    finish: 'Finish',
    tip: 'Tip',
    more: 'More',
    search: 'Search',
    moveFolder: 'Move to folder',
    moveRecycle: 'Move to Recycle Bin',
    recover: 'Restore',
    myFolder: 'My Folders',
    createNewFolder: '+ New Folder',
  },
  aside: {
    allFile: 'All Files',
    allTypes: 'All Types',
    allFolder: 'Folder',
    noFolder: 'No folders',
    setting: 'Preferences',
    helpFeed: 'Help & Feedback',
    code: 'QRCode',
    scanCode: 'Scan to download the app',
  },
  login: {
    title: 'Login',
    emailLogin: 'Email Login',
    phoneLogin: 'Phone Login',
    loginBtn: 'Login',
    forgot: 'Forgot password',
    noAccount: 'No account yet?',
    register: 'Register now',
    agreementPrefix: 'By continuing, you agree to the',
    loginSuccess: 'Login successful!',
    loginFail: 'Login failed. Please check your email or phone number and password.',
    getCode: 'Get Code',
    codeSent: 'Verification code sent',
    codeFail: 'Failed to send verification code, please try again later!',
    resend: 'Resend',
    resendIn: 's to resend',
  },
  profile: {
    avatar: 'Avatar',
    nickname: 'Nickname',
    personalInfo: 'Personal Info',
    language: 'Language',
    logout: 'Logout',
    privacy: 'Privacy Policy',
    manual: 'User Guide',
    userAgreement: 'User Agreement',
  },
  register: {
    title: 'Register Account',
    agree: 'I have read and agree to the',
    submit: 'Submit',
    agreeTip: 'Please agree to the User Agreement and Privacy Policy!',
    success: 'Registration successful! Please login',
    fail: 'Registration failed, please try again later!',
  },
  resetPassword: {
    title: 'Reset Password',
    code: 'Enter the verification code',
    codeRequired: 'Please enter the verification code!',
    getCode: 'Get Code',
    codeSent: 'Verification code sent, please check your email',
    codeFail: 'Failed to send verification code, please try again later!',
    newPassword: 'Please enter your new password!',
    submit: 'Confirm',
    emailTip: 'Please enter your email first!',
    success: 'Password reset successful, please login again!',
    fail: 'Password reset failed, please try again later!',
  },
  feedback: {
    title: 'Feedback',
    contentLabel: 'Your question or suggestion',
    contentPlaceholder: 'Please describe your issue or suggestion in detail...',
    contentRequired: 'Please enter details',
    typeLabel: 'Type',
    typeLabelHolder: 'Please select a feedback type',
    typeRequired: 'Please select a feedback type',
    typeBug: 'Bug',
    typeFeature: 'Feature Request',
    typeUI: 'UI Optimization',
    typePerformance: 'Performance Issue',
    typeOther: 'Other',
    contactLabel: 'Contact Info',
    contactRequired: 'Please enter your contact info',
    contactPlaceholder: 'Please enter your contact info',
    submit: 'Submit Feedback',
    success: 'Thank you for your feedback!',
    fail: 'Submission failed, please try again later',
  },
  file: {
    welcome: 'Welcome to MindRec!',
    listTitle: 'File Records',
    recycle: 'Recycle Bin',
    deleteTitle: 'Delete File',
    deleteContent: 'This file will be permanently deleted and cannot be recovered. Are you sure you want to delete it?',
    deleteOk: 'Delete',
    deleteCancel: 'Cancel',
    deleteSuccess: 'File deleted successfully',
    deleteFail: 'Failed to delete file, please try again later',
    transcription: 'Transcription',
    welcomeTranscription: 'Try AI-powered transcription',
    generate: 'Generate',
    transcribing: 'Transcribing...',
    transcribingTip: 'This may take a few minutes. The result will be displayed automatically when finished. You can leave this page or wait here.',
    transcribeFail: 'Transcription failed!',
    transcribeFailTip: 'Failed to generate transcription. Please try again.',
    regenerate: 'Regenerate',
    regenerateTrans: 'Regenerate transcription for this recording?',
    regenerateSummary: 'Regenerate summary for this recording?',
    summaryGenerating: 'Summary is being generated...',
    summaryGeneratingTip: 'Transcription is done. Summary will be ready in a few minutes. You can wait or view the transcription.',
    viewTranscription: 'View Transcription',
    summaryFail: 'Summary failed',
    summaryFailTip: 'Failed to generate summary. Please try again.',
    selectTemplate: 'Select Template',
    selectTemplateLanguage: 'Recording Language',
    meetingSummary: 'Meeting Summary',
    topic: 'Topic',
    todo: 'To-do',
    interview: 'Interview',
    qa: 'Q&A',
    opinion: 'Opinion',
    speech: 'Speech',
    summary: 'Summary',
    question: 'Question',
    startTranscribing: 'Starting transcription...',
    transcribeStarted: 'Transcription started, please check back later.',
    transcribeFailRetry: 'Transcription failed, please try again later.',
    transcribe: 'Transcribe',
    retranscribe: 'Retranscribe',
    resummarize: 'Resummarize',
    rename: 'Rename',
    AddFolder: 'Create Folder',
    addFolderPlaceholder: 'Please enter the folder name',
    renamePlaceholder: 'Please enter new name',
    renameOk: 'Confirm',
    renameCancel: 'Cancel',
    renameSuccess: 'File name updated successfully',
    createFolderFail: 'Failed to create folder, please try again later',
    createFolderSuccess: 'Folder created successfully',
    renameFail: 'Failed to update file name, please try again later',
    renameUnchanged: 'No changes were made to the file name',
    renameRequired: 'Please enter a new file name',
    delete: 'Delete',
    copyTranscription: 'Copy Transcribed Text',
    copySummary: 'Copy Summary Text',
    exportTranscription: 'Export Transcription',
    exportSummary: 'Export Summary',
    exportMindmap: 'Export Mind Map',
    exportMp3: 'Export Audio',
    copy: 'Copy',
    export: 'Export',
    empty: 'No data available',
    exportSuccess: 'Export successful',
    exportFail: 'Export failed',
    syncTip: 'Learn how to sync data',
    syncTipDesc: 'To view your data here, open the latest version of the MindRec APP and enable MindRec PRIVATE CLOUD.',
    copySuccess: 'Content copied to clipboard',
    dateTime: 'Date & Time',
    location: 'Location',
    attendees: 'Attendees',
    meetingRecord: 'Meeting Record',
    nextStep: 'Next Step',
    interviewer: 'Interviewer',
    conclusion: 'Conclusion',
    speaker: 'Speaker',
    abstract: 'Abstract',
    keyPoints: 'Key Points',
    questions: 'Questions',
    assignments: 'Assignments',
    showList: 'Show List',
    hideList: 'Hide List',
    hideTranscript: 'Hide Transcription',
    showTranscript: 'Show Transcription',
    summaryz: 'Summary',
    mind: 'Mind Map',
    zd: 'Auto',
    zdTag1: 'Adaptive Structure',
    zx: 'Consultation',
    zxTag1: 'Achievements',
    zxTag2: 'Decisions',
    hb: 'Report',
    hbTag1: 'Progress',
    hbTag2: 'Problems',
    tl: 'Discussion',
    tlTag1: 'Conclusions',
    tlTag2: 'Key points',
    bj: 'Class Notes',
    bjTag1: 'Knowledge points',
    bjTag2: 'Explanation',
    px: 'Training',
    pxTag1: 'Key Points',
    pxTag2: 'Notes',
    xq: 'Needs Assessment',
    xqTag1: 'Pain Points',
    xqTag2: 'Expectations',
    moveSuccess: 'Moved successfully',
    moveFail: 'Failed to move',
    moveSelectFile: 'Please select a folder to move',
    notCate: 'Uncategorized',
    recoverSuccess: 'Restored successfully',
    recoverFail: 'Failed to restore',
    editFolder: 'Edit Folder',
    folderNameUnchanged: 'Folder name unchanged',
    folderExists: 'Folder already exists',
    invalidCharacters: 'Name contains invalid characters, please modify and retry',
    updateFolderSuccess: 'Folder updated successfully',
    updateFolderFail: 'Failed to update folder',
    deleteFolderTips: 'This folder will be permanently deleted, and files in the folder will be moved to the recycle bin. Are you sure you want to delete it?',
    insufficientBalance: 'Insufficient Balance',
    insufficientBalanceMessage: 'Not enough transcription minutes to complete this task.',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    fitView: 'Fit View',
    editTitle: 'Click to edit title',
    editContent: 'Click to edit content',
    titlePlaceholder: 'Enter title...',
    contentPlaceholder: 'Enter content, or use / command to insert blocks',
    saving: 'Saving...',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Failed to save',
    titleSaveSuccess: 'Title updated',
    contentSaveSuccess: 'Content updated',
    sessionExpired: 'Session expired, please log in again',
  },
  blockNoteEditor: {
    heading2: 'Heading 2',
    heading3: 'Heading 3',
    heading4: 'Heading 4',
    quote: 'Quote',
    bulletList: 'Bullet List',
    numberedList: 'Numbered List',
  },
  vip: {
    lock: "Unlock Free Membership",
    lockDesc: "Bind a device to activate membership benefits",
    lockNowBtnText: "Unlock Now",
    starVipName: "Basic Membership",
    proVipName: "Standard Membership",
    unlimitedVipName: "Premium Membership",
    transTimeName: "Minute Pack",
    timeReset: "Renews",
    timeEnd: "Expires",
    usedUp: "Used Up",
    minutesLeft: "{count} min remaining",
    lockTitle: "Unlock Free Membership",
    lockSubTitle: "Please open the MindRec app and bind your device to activate membership benefits",
    lockRights1: "Free monthly transcription minutes",
    lockRights2: "Smart summary templates for every scenario",
    lockRights3: "Speaker identification in multi-person recordings",
    lockRights4: "Smart noise reduction for improved audio playback",
    lockRights5: "Export to multiple formats"
  }
};